<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      phaseOneShow: false,
      tData: {
        tokenManagement: [
          {
            id: '1',
            tokenNumber: 'A/AA/AAAA',
            tokenOwner: 'Dishub',
            totalFleet: '10',
            defaultFleet: 'Ya',
          },
        ],
      },
      selected: {
        tokenManagement: [],
      },
      selectedModel: {
        tokenManagement: [],
      },
      allSelected: {
        tokenManagement: false,
      },
      indeterminate: {
        tokenManagement: true,
      },
      show_model: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'tokenNumber',
    }
  },

  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tData.tokenManagement.length
    },

    totalTrue() {
      return this.selectedModel.tokenManagement.filter((c) => c === true)
    },

    title() {
      return 'Manajemen Token'
    },

    tokenManagement() {
      return [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'tokenNumber',
          label: 'Nomor Token',
          sortable: true,
        },
        {
          key: 'tokenOwner',
          label: 'Pemilik Token',
          sortable: true,
        },
        {
          key: 'totalFleet',
          label: 'Total Kendaraan Terdaftar',
          sortable: true,
        },
        {
          key: 'defaultFleet',
          label: 'Default Kendaraan Baru',
          sortable: true,
        },
      ]
    },
  },

  methods: {
    /**
     * Search the table data with search input
     */

    focusSearch() {
      this.$refs.searchInput.focus()
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.index)
      } else {
        var myIndex = this.selected[param].indexOf(data.index)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },

    toDelete(param) {
      this.selected[param].sort()
      this.selected[param].reverse()
      this.selected[param].forEach((row) => {
        this.$delete(this.tData[param], row)
      })
      this.selected[param] = []
      this.selectedModel[param] = []

      this.indeterminate[param] = false
      this.allSelected[param] = false
      for (let i = 0; i < this.tData[param].length; i++) {
        this.selectedModel[param].push(false)
      }
    },

    clearCheck() {
      this.selected = {
        tokenManagement: [],
      }

      this.selectedModel = {
        tokenManagement: [],
      }
    },
  },
}
</script>
  
  <template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p>Mengelola token integrasi kendaraan dengan pihak lain</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button variant="outline-primary" @click="$router.go(-1)">
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-4"></div>
        <div class="col-md-8 text-end">
          <b-button
            v-if="selected.tokenManagement.length"
            v-b-modal.modal-delete
            variant="outline-danger"
            class="ms-2"
          >
            <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
          </b-button>
          <b-button variant="primary" class="ms-2" @click="$router.push({ name: 'Token Add' })">
            <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-start">
                <h6 v-if="totalTrue.length" class="mc-row-check">
                  <span class="badge btn-success">{{ totalTrue.length }}</span>
                  {{ $t('global.selectedRows') }}.
                  <a class="color-primary" @click="clearCheck">{{
                    $t('global.action.clearAll')
                  }}</a>
                </h6>
              </div>

              <!-- Search -->
              <div class="float-end">
                <div class="mc-table-view">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label
                      class="d-inline-flex align-items-center mc-table-view__search ms-2"
                      @click="focusSearch"
                    >
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2"
                        ref="searchInput"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive my-3 border border-1">
              <b-table
                small
                show-empty
                :fields="tokenManagement"
                :items="tData.tokenManagement"
                class="datatables"
                responsive="sm"
                sort-by="tokenNumber"
                empty-table
                :empty-text="$t('global.emptyTable')"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #head(columnCheck)>
                  <div class="form-check">
                    <b-form-checkbox
                      @change="toggleAll($event, 'tokenManagement')"
                      v-model="allSelected.tokenManagement"
                      :indeterminate="indeterminate.tokenManagement"
                      :value="true"
                      :unchecked-value="false"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template #cell(columnCheck)="data">
                  <div class="form-check">
                    <b-form-checkbox
                      @change="checkTable($event, data, 'tokenManagement')"
                      v-model="selectedModel.tokenManagement[data.index]"
                      :value="true"
                      :unchecked-value="false"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template #cell(tokenNumber)="data">
                  <a @click="$router.push({ name: 'Token Add' })">
                    <strong class="text-primary">
                      {{ data.item.tokenNumber }}
                    </strong>
                  </a>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t('global.show') }}
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    {{ $t('global.entry') }}
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Delete Confirmation -->
    <b-modal class="mc-modal" id="modal-delete" title="Hapus" size="md" centered scrollable>
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
        <b-list-group>
          <b-list-group-item
            v-for="tokenManagement in selected.tokenManagement"
            :key="tokenManagement.id"
            >{{ tokenManagement.tokenNumber }}</b-list-group-item
          >
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.no') }}
            </b-button>
            <b-button @click="toDelete" variant="primary"> {{ $t('global.yes') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>